import {
  ChoiceGroup,
  DefaultButton,
  Icon,
  PrimaryButton,
  Spinner,
  SpinnerSize,
  TextField,
} from "@fluentui/react";
import { useFormik } from "formik";
import React, { useEffect, useState, useContext, useCallback } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import {
  AuthRoutes,
  APIs,
  ACTIONS,
  USERTYPES,
  TOAST_TYPE,
} from "../../constants/Constants";
import { FirmSchema } from "../../Schemas/FirmSchema";
import {
  addHospital,
  editFirmSettings,
  getFirmSettingDetails,
  getHospitalDetails,
  getImage,
  saveFirmSettingDetails,
} from "../../service/FirmServices";
import HeaderFileCheck from "./components/HeaderFileChecks/HeaderFileChecks";
import { t } from "i18next";
import {
  InitialData,
  editBreadCrumbItems,
  addbreadCrumbItems,
  passwordProtectedOptions,
  viewBreadCrumbItems,
} from "../Firm/helpers/InitialData";
import {
  adminFirmEditDataModal,
  firmDataModal,
} from "../Hospital/helpers/DataModal";
import HospitalDetailsSection from "./components/HospitalDetailsSection/HospitalDetailsSection";
import "./firm.css";
import ContactDetailsSection from "./components/ContactDetailsSection/ContactDetailsSection";
import PasswordProtectedSection from "./components/PasswordProtectionSection/PasswordProtectionSection";
import { editTabStatusInitialIcon } from "./helpers/InitialData";
import firmContext from "../../context/firms/FirmContext";
import userContext from "../../context/users/UserContext";
import TabContainer from "../../components/TabContainer/TabContainer";
import HospitalSettings from "./components/HospitalSettings/HospitalSettings";
import { addTabStatusInitialValue } from "../User/helpers/InitialData";
import CustomTab from "../../components/TabContainer/CustomTab";
import FirmTechnicianList from "./FirmTechnician/FirmTechnicianList";
import FirmDoctorList from "./FirmDoctor/FirmDoctorList";
import { getFirmTabs } from "./helpers/FirmTabs";
import { Country, State, City } from "country-state-city";
import loaderContext from "../../context/loader/LoaderContext";
import NotAllowed from "../../components/NotAllowed";
import DialogBox from "../../components/Modal/DialogBox";
import toastContext from "../../context/toast/ToastContext";

const Firm = (props) => {
  let enterprise =
    process.env.REACT_APP_ENTERPRISE_PLATFORM == "true" ||
    process.env.REACT_APP_ENTERPRISE_PLATFORM == true
      ? true
      : false;
  const { roles, loadByUsername, authenticated, firmId, checkForUserAccess } =
    useContext(userContext);

  const {
    errorContactState,
    setErrorContactState,
    resetValues,
    validateContact,
    validateHospitalDetails,
    validateHospitalSettings,
    tabStatus,
    setTabStatus,
    validateConfigureSettings,
    validateOtherSettings,
    validateAutoAssignmentSettings,
    setFirmGlobalErrorState,
    firmGlobalErrorState,
    validatePacsNode,
  } = useContext(firmContext);
  const { showSuccessToast, setSuccessToast } = useContext(userContext);
  const { ref, refAnnotation, setLoaderRunning, setLoaderAnnotationRunning } =
    useContext(loaderContext);
  const { showToastv2 } = useContext(toastContext);
  const [selectedValue, setSelectedValue] = useState(1);
  const [prevState, setPrevState] = useState("0");
  const [totalTabs, setTotalTabs] = useState(1);
  const infoIcon = {
    iconName: "Info",
    style: { fontSize: 13, lineHeight: 1.5 },
  };
  const location = useLocation();
  const navigate = useNavigate();
  const [action, setAction] = useState(props.action);
  let { state } = location;
  const [submitClicked, setSubmitClick] = useState(true);
  const [loading, setLoading] = useState(false);
  const [loadingState, setLoadingState] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const [breadCrumbItems, setBreadCrumBItems] = useState([]);
  const [tabStatusInitialValue, setTabStatusInitialValue] = useState(
    addTabStatusInitialValue
  );
  // const [tabStatus, setTabStatus] = useState(action=="EDIT"?editTabStatusInitialIcon:tabStatusInitialValue);
  const [headerImageValue, setHeaderImageValue] = useState("");
  const [footerImageValue, setFooterImageValue] = useState("");
  const [signature2ImageValue, setSignature2ImageValue] = useState("");
  const [signature3ImageValue, setSignature3ImageValue] = useState("");
  const [editConfigurationSetting, setEditConfigurationSetting] =
    useState(false);
  const [hospitalDetails, setHospitalDetails] = useState({});
  const [hospitalUserList, setHospitalUserList] = useState([]);
  const [hospitalDoctorList, setHospitalDoctorList] = useState([]);
  const [modalityList, setModalityList] = useState([]);
  const [modalityWithSubModalityList, setModalityWithSubModalityList] =
    useState([]);
  const [historyModalityList, setHistoryModalityList] = useState([]);
  const [isMinimal, setIsMinimal] = useState(false);
  const [firmTechnicianOwnFirm, setFirmTechnicianOwnFirm] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(() => {
    const country = Country.getCountryByCode("IN");
    return {
      value: country.isoCode,
      label: country.name,
    };
  });
  const [hospitalCheckList, setHospitalCheckList] = useState([]);
  const [firmListForProviders, setFirmListForProviders] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [currFirmId, setcurrFirmId] = useState(
    searchParams.get("firmId") ? parseInt(searchParams.get("firmId")) : ""
  );
  const [firmType, setFirmType] = useState(
    props.action === ACTIONS.EDIT || props.action === ACTIONS.VIEW
      ? parseInt(searchParams.get("type"))
      : ""
  );
  const [viewWarningOnly, setViewWarningOnly] = useState(
    searchParams.get("viewWarningOnly") == "true" ? true : false
  );
  const ownFirm =
    currFirmId == "" || currFirmId == null || currFirmId == undefined
      ? true
      : false;
  const [showSelectModalityDialog, setShowSelectModalityDialog] =
    useState(false);
  const [noSelectionErrorMessage, setNoSelectionErrorMessage] = useState("");
  const [clientId, setClientId] = useState(0);
  const [userFirmId, setUserFirmId] = useState(0);
  const [headerImageFileName, setHeaderImageFileName] = useState("");
  const [footerImageFileName, setFooterImageFileName] = useState("");
  const [isHeaderFileDeleted, setIsHeaderFileDeleted] = useState(false);
  const [isFooterFileDeleted, setIsFooterFileDeleted] = useState(false);
  const [isSignatureFile2Deleted, setIsSignatureFile2Deleted] = useState(false);
  const [isSignatureFile3Deleted, setIsSignatureFile3Deleted] = useState(false);
  const [selectedModalityAndSubModality, setSelectedModalityAndSubModality] =
    useState([]);
  const [show, setShow] = useState(true);
  const [autoAssignEnabled, setAutoAssignEnabled] = useState(false);
  const [pediatricAssignmentEnabled, setPediatricAssignmentEnabled] = useState(false);
  const [selectedPediatricModalityId, setSelectedPediatricModalityId] = useState([]);
  const [showPriorsStudiesList, setShowPriorsStudiesList] = useState([]);

  const fetchImage = async (flagImage, imageName, apiUrl) => {
    let response = await getImage(imageName, apiUrl);
    let base64Flag = "data:image/jpeg;base64,";
    if (response.status == 200) {
      if (flagImage == "headerImage") {
        setHeaderImageValue(base64Flag + response.data.data);
      } else if (flagImage == "footerImage") {
        setFooterImageValue(base64Flag + response.data.data);
      } else if (flagImage == "signature2Image") {
        setSignature2ImageValue(base64Flag + response.data.data);
      } else if (flagImage == "signature3Image") {
        setSignature3ImageValue(base64Flag + response.data.data);
      }
    }
  };

  useEffect(() => {
    if (!authenticated) {
      loadByUsername();
    }
    getBreadCrumbItems();
  }, [roles, firmType]);

  useEffect(() => {
    checkForUserAccess()
  }, [roles[0]]);

  const [selectedRadiologistMap, setSelectedRadiologistMap] = useState(new Map());
  const [radiologistList, setRadiologistList] = useState([]);
  const [checkAllRadiologist, setCheckAllRadiologist] = useState(false);

  const [selectedSupervisorMap, setSelectedSupervisorMap] = useState(new Map());
  const [supervisorList, setSupervisorList] = useState([]);
  const [checkAllSupervisor, setCheckAllSupervisor] = useState(false);

  const [pacsNodeList, setPacsNodeList] = useState([]);

  const [availablePacsList, setAvailablePacsList] = useState([]);
  const [checkAllPacs, setCheckAllPacs] = useState(false);
  const [selectedPacsList, setSelectedPacsList] = useState([]);

  const prepareRadiologistList = (list, checkList) => {
    setRadiologistList(list);

    checkList.map((radiologist) => {
      setSelectedRadiologistMap((prevMap) => {
        const newMap = new Map(prevMap);
        newMap.set(
          parseInt(radiologist.userId),
          radiologist.modalityIds.map(Number)
        );
        return newMap;
      });
    });

    let result = [];

    list.map((l) => {
      const mapping = checkList.filter((cl) => cl.userId == l.id);
      result.push({
        userId: l.id,
        name: l.username,
        modalityIds: mapping.length === 0 ? [] : mapping[0]?.modalityIds,
      });
    });

    return result;
  };

  const prepareSupervisorList = (list, checkList) => {
    setSupervisorList(list);

    checkList.map((supervisor) => {
      setSelectedSupervisorMap((prevMap) => {
        const newMap = new Map(prevMap);
        newMap.set(
          parseInt(supervisor.userId),
          supervisor.modalityIds.map(Number)
        );
        return newMap;
      });
    });
    let result = [];

    list.map((l) => {
      const mapping = checkList.filter((cl) => cl.userId == l.id);
      result.push({
        userId: l.id,
        name: l.username,
        modalityIds: mapping.length === 0 ? [] : mapping[0]?.modalityIds,
      });
    });

    return result;
  };

  const formattedAutoAssignModality = () => {
    return selectedModalityAndSubModality;
  };

  const preSelectedAutoAssignModality = (
    autoAssignModalityWithSubModalityIds
  ) => {
    let list1 = [];
    autoAssignModalityWithSubModalityIds.map((modality, index) => {
      list1.push({
        modalityId: modality.modalityId,
        subModalities: modality.subModalities.map((sm) => sm.id),
      });
    });
    setSelectedModalityAndSubModality(list1);
    // setSelectedModality(list1.map((m)=>m.modalityId));
  };

  const [editFirmResponseState, setEditFirmResponseState] = useState(null);
  const [firmDataState, setFirmDataState] = useState(null);

  const setValuesForFirm = async (data, editFirmResponse) => {
    setValues({
      id: data.firmDto.id,
      name: data?.firmDto?.name,
      code: data?.firmDto?.code,
      address: data?.firmDto?.address,
      country: data?.firmDto?.country,
      state: data?.firmDto?.state,
      city: data?.firmDto?.city,
      customerSupportNumber:data?.firmDto?.customerSupportNumber,
      active: data.firmDto.active,
      firmType: data.firmDto?.firmType,
      firmRole: data.firmDto?.firmRole,
      password_protected: data?.firmDto?.password_protected,
      triageCTStudies: data?.firmDto?.triageCTStudies,
      triageXRAYStudies: data?.firmDto?.triageXRAYStudies,
      addTimeToReport: data?.firmDto?.addTimeToReport,
      addDateToReport: data?.firmDto?.addDateToReport,
      addSupervisorSignature: data?.firmDto?.addSupervisorSignature,
      isDOC: data?.firmDto?.isDOC,
      isDOCX: data?.firmDto?.isDOCX,
      isPDF: data?.firmDto?.isPDF,
      isPDFWithImage: data?.firmDto?.isPDFWithImage,
      isPDFWithKeyImage: data?.firmDto?.isPDFWithKeyImage,
      isDOCXWithKeyImage: data?.firmDto?.isDOCXWithKeyImage,
      isMinimalAccount: data?.firmDto?.isMinimalAccount,
      qcEnabled:
        editFirmResponse?.data.data.qcSettingsResponseDto.qcSettingDto
          .qcEnabled == 1
          ? true
          : false,
      twoSignaturesAllowed:
        editFirmResponse?.data.data.qcSettingsResponseDto.qcSettingDto
          .twoSignaturesAllowed == 0
          ? false
          : true,
      modalityIds:
        editFirmResponse?.data.data.qcSettingsResponseDto.qcSettingDto.modalityIds.filter(
          (m) => m != null
        ),
      reportHeaderDto: {
        headerImage: data?.firmDto?.reportHeaderDto.headerImage,
        footerImage: data?.firmDto?.reportHeaderDto.footerImage,
        headerImageUrl: data?.firmDto?.reportHeaderDto.headerImageUrl,
        footerImageUrl: data?.firmDto?.reportHeaderDto.footerImageUrl,
        isHeaderImageDeleted: data?.firmDto?.reportHeaderDto.isHeaderImageDeleted ? 1 : 0,
        isFooterImageDeleted: data?.firmDto?.reportHeaderDto.isFooterImageDeleted ? 1 : 0,
      },
      signature2Dto: {
        signatureFile2: data?.firmDto?.signature2Dto.signatureImageUrl,
        signatureText:
          data?.firmDto?.signature2Dto.signatureText == null
            ? ""
            : data.firmDto.signature2Dto.signatureText,
        isSignatureImageDeleted: data?.signature3Dto?.isSignatureImageDeleted ? 1 : 0
      },
      signature3Dto: {
        signatureFile3: data?.firmDto?.signature3Dto.signatureImageUrl,
        signatureText:
          data?.firmDto?.signature3Dto.signatureText == null
            ? ""
            : data.firmDto.signature3Dto.signatureText,
        isSignatureImageDeleted: data?.signature3Dto?.isSignatureImageDeleted ? 1 : 0
      },
      contact1: {
        name:
          data.firmDto.contact1.name == null ? "" : data.firmDto.contact1.name,
        email:
          data.firmDto.contact1.email == null
            ? ""
            : data.firmDto.contact1.email,
        type:
          data.firmDto.contact1.type == null ? "" : data.firmDto.contact1.type,
        mobile:
          data.firmDto.contact1.mobile == null
            ? ""
            : data.firmDto.contact1.mobile,
        landline:
          data.firmDto.contact1.landline == null
            ? ""
            : data.firmDto.contact1.landline,
      },
      contact2: {
        name:
          data.firmDto.contact2.name == null ? "" : data.firmDto.contact2.name,
        email:
          data.firmDto.contact2.email == null
            ? ""
            : data.firmDto.contact2.email,
        type:
          data.firmDto.contact2.type == null ? "" : data.firmDto.contact2.type,
        mobile:
          data.firmDto.contact2.mobile == null
            ? ""
            : data.firmDto.contact2.mobile,
        landline:
          data.firmDto.contact2.landline == null
            ? ""
            : data.firmDto.contact2.landline,
      },
      contact3: {
        name:
          data.firmDto.contact3.name == null ? "" : data.firmDto.contact3.name,
        email:
          data.firmDto.contact3.email == null
            ? ""
            : data.firmDto.contact3.email,
        type:
          data.firmDto.contact3.type == null ? "" : data.firmDto.contact3.type,
        mobile:
          data.firmDto.contact3.mobile == null
            ? ""
            : data.firmDto.contact3.mobile,
        landline:
          data.firmDto.contact3.landline == null
            ? ""
            : data.firmDto.contact3.landline,
      },
      // headerFile: null,
      // footerFile: null,
      // signatureFile2: null,
      // signatureFile3: null,
      reqBlankLines: data.firmDto.reqBlankLines,
      reqBlankLinesAfterHeader:data.firmDto.reqBlankLinesAfterHeader,
      headerTextLine1: data.firmDto.headerTextLine1,
      headerTextLine2: data.firmDto.headerTextLine2,
      isFirmPacsReceiver: data.firmPacsReceiver,
      addPrintDisclaimer:
        roles[0] === USERTYPES.SUPERVISOR ||
        parseInt(searchParams.get("type")) === 1
          ? data?.firmDto?.addPrintDisclaimer
          : editFirmResponse?.data.data.disclaimerDto.addPrintDisclaimer,
      printDisclaimerText:
        roles[0] === USERTYPES.SUPERVISOR ||
        parseInt(searchParams.get("type")) === 1
          ? data?.firmDto?.printDisclaimerText
          : editFirmResponse?.data.data.disclaimerDto.printDisclaimerText,
      addendumDisclaimerEnabled: data?.firmDto?.addendumDisclaimerEnabled,
      addendumDisclaimerText: data?.firmDto?.addendumDisclaimerText,
      studyLinkExpiryTime: data?.firmDto?.studyLinkExpiryTime,
      enableShareReportLink: data?.firmDto?.enableShareReportLink,
      reportLinkExpiryTime: data?.firmDto?.reportLinkExpiryTime,
      accountWarning: data.accountWarningMessage,
      priorityCount: data.priorityStudyCount,
      branchCode: editFirmResponse?.data.data.configureSettingDto?.branchCode ? editFirmResponse?.data.data.configureSettingDto?.branchCode : data.configureSettingDto?.branchCode,
      showWord: editFirmResponse?.data.data.configureSettingDto?.showWord ? editFirmResponse?.data.data.configureSettingDto?.showWord : data.configureSettingDto?.showWord,
      selectedSubModalityListNumber: editFirmResponse?.data.data.configureSettingDto?.selectedSubModalityListNumber ? editFirmResponse?.data.data.configureSettingDto?.selectedSubModalityListNumber : data.configureSettingDto?.selectedSubModalityListNumber,
      updatedTimeString: null,
      schemeCode: null,
      autoAssignModalityWithSubModalityIds:
        editFirmResponse?.data.data.autoAssignEnableDto
          .modalityWithSubModalityIds == null
          ? []
          : editFirmResponse?.data.data.autoAssignEnableDto
              .modalityWithSubModalityIds,
      autoAssignModalityIds:
        editFirmResponse?.data.data.autoAssignEnableDto.modalityIds == null
          ? []
          : editFirmResponse?.data.data.autoAssignEnableDto.modalityIds.filter(
              (m) => m != null && m != ""
            ),
      autoAssignEnable:
        editFirmResponse?.data.data.autoAssignEnableDto.autoAssignEnabled,
      exactMatchEnable:
        editFirmResponse?.data.data.autoAssignEnableDto.exactMatchEnabled,
      pediatricAssignmentEnabled:
        editFirmResponse?.data.data.autoAssignEnableDto
          .pediatricAssignmentEnabled,
      selectedPediatricModalityId:
        editFirmResponse?.data.data.autoAssignEnableDto
          .selectedPediatricModalityId == null
          ? []
          : editFirmResponse?.data.data.autoAssignEnableDto.selectedPediatricModalityId.filter(
              (m) => m != null && m != ""
            ),
      isClientWarning: ownFirm
        ? data.isClientWarning
        : data.firmDto.isClientWarning,
      techinicianList: data.userList1,
      doctorList: data.userList2,
      allowDownloadStudy: data?.firmDto?.allowDownloadStudy,
      allowDownloadReport: data?.firmDto?.allowDownloadReport,
      enableQRCodeInReport: data?.firmDto?.enableQRCodeInReport,
      enableStudySharingLinkInReport: data?.firmDto?.enableStudySharingLinkInReport,
      enableUnassignmentService: data?.firmDto?.enableUnassignmentService,
      firmEnableUnassignmentService: editFirmResponse?.data.data.unassignmentServiceDto.firmEnableUnassignmentService,
      historyAvailable:
        editFirmResponse?.data.data.historyAvailableDto.historyAvailable,
      historyModalityIds:
        editFirmResponse?.data.data.historyAvailableDto.modalityIds == null
          ? []
          : editFirmResponse?.data.data.historyAvailableDto.modalityIds.filter(
              (m) => m != null && m != ""
          ),
      clinicalNoteMandatory: editFirmResponse?.data.data.historyAvailableDto.clinicalNoteMandatory,
      subModalityMandatory: editFirmResponse?.data.data.historyAvailableDto.subModalityMandatory,
      radiologistIdList:
        roles[0] === USERTYPES.FIRMADMIN &&
        !ownFirm &&
        parseInt(searchParams.get("type")) === 0
          ? prepareRadiologistList(
              editFirmResponse?.data.data.connectedUsersResponseDto.userList,
              editFirmResponse?.data.data.connectedUsersResponseDto.userchklist
            )
          : [],
      supervisorIdList:
        roles[0] === USERTYPES.FIRMADMIN &&
        !ownFirm &&
        parseInt(searchParams.get("type")) === 0
          ? prepareSupervisorList(
              editFirmResponse?.data.data.connectedUsersResponseDto
                .supervisorList,
              editFirmResponse?.data.data.connectedUsersResponseDto
                .supervisorChkList
            )
          : [],
      firmIdList: data?.hospitalchklist?.map((hid) => "" + hid),
      showPriorsStudies: (roles[0] === USERTYPES.ADMIN || (roles[0] === USERTYPES.FIRMADMIN && ownFirm)) ? data.firmDto?.showPriorsStudies : editFirmResponse?.data.data.disclaimerDto.showPriorsStudies,
      enableSecondaryCapture: (roles[0] === USERTYPES.FIRMADMIN && ownFirm) ? data.firmDto?.enableSecondaryCapture : editFirmResponse?.data.data.firmSettingsDto.enableSecondaryCapture,
      enableGenkiStudyInference: (roles[0] === USERTYPES.FIRMADMIN && ownFirm) ? data.firmDto?.enableGenkiStudyInference : editFirmResponse?.data.data.firmSettingsDto.enableGenkiStudyInference, 
      showPrirosStudiesList: data?.showPriorsConnectionDto,
      cxrVersionViewer: data?.firmDto?.cxrVersionViewer,
      cxrVersionStudyList: data?.firmDto?.cxrVersionStudyList,
      boneEnabled: data?.firmDto?.boneEnabled,
      showProbability: data?.firmDto?.showProbability,
      showFindings: data?.firmDto?.showFindings,
      subtleFindings: data?.firmDto?.subtleFindings,
      showAboveThresholdScore: data?.firmDto?.showAboveThresholdScore,
    });
    handleRegion(
      data?.firmDto?.country,
      data?.firmDto?.state,
      data?.firmDto?.city
    );
  };

  const fetchData = async () => {
    setLoaderRunning(true);
    ref.current.continuousStart();
    const body = {
      firmId: searchParams.get("firmId")
        ? parseInt(searchParams.get("firmId"))
        : null,
      type: searchParams.get("type")
        ? parseInt(searchParams.get("type"))
        : null,
      viewWarningOnly: searchParams.get("viewWarningOnly")
        ? searchParams.get("viewWarningOnly") == "true"
        : false,
      paginationUserDto: {
        pageNumber: 0,
        pageSize: 5,
        sortField: "name",
        sortOrder: false,
      },
      paginationHospitalDto: {
        pageNumber: 0,
        pageSize: 5,
        sortField: "name",
        sortOrder: false,
      },
    };

    const response = await getHospitalDetails(body);
    let editFirmResponse = null;
    if (
      parseInt(searchParams.get("type")) === 0 &&
      !ownFirm &&
      roles[0] === USERTYPES.FIRMADMIN
    ) {
      editFirmResponse = await getFirmSettingDetails(
        searchParams.get("firmId"),
        searchParams.get("type")
      );
    }
    if (
      response.status === 200 &&
      response.data.result === "SUCCESS" &&
      (!ownFirm &&
      roles[0] === USERTYPES.FIRMADMIN &&
      parseInt(searchParams.get("type")) === 0
        ? editFirmResponse?.status === 200 &&
          editFirmResponse?.data.result === "SUCCESS"
        : true)
    ) {
            setEditFirmResponseState(editFirmResponse);
      setFirmDataState(response.data.data);
      setHospitalDetails(response.data.data.firmDto);
      setModalityList(
        editFirmResponse?.data.data.qcSettingsResponseDto.modalityList
      );
      setModalityWithSubModalityList(
        editFirmResponse?.data.data.qcSettingsResponseDto
          .modalityWithSubModalityList
      );
      setHistoryModalityList(
        editFirmResponse?.data.data.historyAvailableDto.modalityList
      );

      setClientId(editFirmResponse?.data.data.historyAvailableDto.clientId);
      setUserFirmId(editFirmResponse?.data.data.historyAvailableDto.firmId);

      if (parseInt(searchParams.get("type")) === 1) {
        setFirmListForProviders(response.data.data.firmList);
        setHospitalCheckList(
          response.data.data.hospitalchklist.map((id) => "" + id)
        );
      }

      var details = response.data.data.firmDto;
      if (
        response.data.data.userList1 != null ||
        response.data.data.userList1 != undefined
      ) {
        setHospitalUserList(response.data.data.userList1);
      }
      if (
        response.data.data.userList2 != null ||
        response.data.data.userList2 != undefined
      ) {
        setHospitalDoctorList(response.data.data.userList2);
      }
      const data = response.data.data;
      if(response.data.data.showPriorsConnectionDto != null || response.data.data.showPriorsConnectionDto != undefined) {
        setShowPriorsStudiesList(response.data.data.showPriorsConnectionDto);
      }

      await setValuesForFirm(data, editFirmResponse);

      setIsMinimal(data?.firmDto?.isMinimalAccount == 1 ? true : false);
      if (roles[0] === USERTYPES.FIRMTECHNICIAN) {
        setFirmTechnicianOwnFirm(data.ownFirm);
      }
      setHeaderImageFileName(data?.firmDto?.reportHeaderDto.headerImageUrl);
      setFooterImageFileName(data?.firmDto?.reportHeaderDto.footerImageUrl);
      preSelectedAutoAssignModality(
        editFirmResponse?.data.data.autoAssignEnableDto
          .modalityWithSubModalityIds == null
          ? []
          : editFirmResponse?.data.data.autoAssignEnableDto
              .modalityWithSubModalityIds
      );
      setPacsNodeList(data?.firmDto?.pacsNodeList);
      setAvailablePacsList(editFirmResponse?.data?.data?.configurePacsDto?.availablePacsNodes);
      setSelectedPacsList(editFirmResponse?.data?.data?.configurePacsDto?.selectedPacsNodes);
      setLoading(false);
      setLoaderRunning(false);
      ref.current.complete();
    } else {
      setLoading(false);
      setLoaderRunning(false);
      ref.current.complete();
      setShow(false);
    }
    // return values;
  };

  let data = InitialData(props.firmType, props.firmRole, roles[0]);

  useEffect(()=>{
      console.log("Available PACS list :", availablePacsList);
      console.log("Selected PACS list :", selectedPacsList);
  },[availablePacsList, selectedPacsList])

  useEffect(() => {
    if (action !== ACTIONS.ADD) {
      if (roles.length !== 0) fetchData();
    }
  }, [roles, action]);

  const handleShowFileError = (errors) => {
    let errorShown = false;
    console.log("--- Error ----",errors);
    errors.map((error)=>{
        switch(true){
          case ((error.fieldName == "headerFile" || error.fieldName == "footerFile" 
          || error.fieldName == "signatureFile2" || error.fieldName == "signatureFile2") && !errorShown):
            showToastv2(TOAST_TYPE.ERROR, error.defaultMessage);
            errorShown = true;
            break;
          default:
            break;
        }
    })
  }

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setValues,
  } = useFormik({
    initialValues: data,
    // validationSchema: FirmSchema,
    onSubmit: async (values) => {
      if (submitClicked) {
        if (
          action === ACTIONS.EDIT &&
          roles[0] === USERTYPES.FIRMADMIN &&
          !ownFirm &&
          parseInt(searchParams.get("type")) == 0
        ) {
          setLoadingState("Submitting hospital details");
          setLoading(true);
          setLoaderRunning(true);
          ref.current.continuousStart();

          let EditFirmDto = adminFirmEditDataModal(
            values,
            clientId,
            userFirmId,
            formattedAutoAssignModality,
            selectedRadiologistMap,
            selectedSupervisorMap,
            selectedPacsList
          );
          const response = await editFirmSettings(EditFirmDto);

          if (response.status === 200 && response.data.result === "SUCCESS") {
            setSuccessToast(true);
            window.location.assign(response.data.data.data.setViewName);
            setLoading(false);
            setLoaderRunning(false);
            ref.current.complete();
          } else {
            setLoading(false);
            setLoaderRunning(false);
            ref.current.complete();
            let errors = response.data.data.errorFields;
            handleShowFileError(errors);
            let globalError = {};
            errors.map((e) => {
              globalError = { ...globalError, [e.fieldName]: e.defaultMessage };
            });
            setFirmGlobalErrorState(globalError);
            setLoading(false);
          }
        } else {
          setLoadingState("Submitting hospital details");
          setLoading(true);
          setLoaderRunning(true);
          ref.current.continuousStart();
          let firmDto = firmDataModal(
            values,
            state,
            roles[0],
            formattedAutoAssignModality,
            hospitalCheckList,
            pacsNodeList,
            showPriorsStudiesList
          );

          const response = await addHospital(
            action,
            firmDto,
            values.reportHeaderDto.headerImage,
            values.reportHeaderDto.footerImage,
            values.signature2Dto.signatureFile2,
            values.signature3Dto.signatureFile3
          );

          if (response.status === 200 && response.data.result === "SUCCESS") {
            tabStatusInitialValue.tab2Status = {
              value: "Completed",
              color: "green",
            };
            let warnings = response.data.data.warningFields;
            if(warnings && warnings.length > 0){
              setLoading(false);
              setLoaderRunning(false);
              warnings.map((e) => {
                showToastv2(
                  TOAST_TYPE.INFO,
                  e.defaultMessage
                  );
              });
              setTimeout(() => {
                  setSuccessToast(true);
                  window.location.assign(response.data.data.viewName);
                  ref.current.complete();
              }, 2000);
            } else {
              setSuccessToast(true);
              window.location.assign(response.data.data.viewName);
              setLoading(false);
              setLoaderRunning(false);
              ref.current.complete();
            }
          } else {
            if(response?.status === 429){
              setLoaderRunning(false);
              ref.current.complete();
              showToastv2(TOAST_TYPE.ERROR, response?.data?.message);
              return;
            }
            let errors = response.data.data.errorFields;
            handleShowFileError(errors);
            let globalError = {};
            errors.map((e) => {
              globalError = { ...globalError, [e.fieldName]: e.defaultMessage };
            });
            setFirmGlobalErrorState(globalError);
            setLoading(false);
            setLoaderRunning(false);
            ref.current.complete();
          }
        }
      }
    },
  });

  const choiceGroupStyles = {
    label: {
      display: "inline",
    },
    flexContainer: {
      columnGap: "1em",
      display: "inline-flex",
      flexDirection: "row",
      flexWrap: "wrap",
    },
  };

  useEffect(() => {
    if (
      firmDataState != null &&
      (action == ACTIONS.EDIT || action === ACTIONS.VIEW)
    ) {
      setValuesForFirm(firmDataState, editFirmResponseState);
    }
  }, [action]);

  useEffect(() => {
    getBreadCrumbItems();
  }, [roles]);

  useEffect(() => {
    // console.log(state.firmDto);
    setSuccessToast(false);
    if (action == ACTIONS.EDIT || action == ACTIONS.VIEW) {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.tabStatusInitialValue = editTabStatusInitialIcon;
        return newVal;
      });
      if (
        hospitalDetails?.reportHeaderDto?.headerImageUrl != "" &&
        hospitalDetails?.reportHeaderDto?.headerImageUrl != null
      ) {
        fetchImage(
          "headerImage",
          hospitalDetails.reportHeaderDto.headerImageUrl,
          APIs.GETHEADERIMAGE
        );
      }
      if (
        hospitalDetails?.reportHeaderDto?.footerImageUrl != "" &&
        hospitalDetails?.reportHeaderDto?.footerImageUrl != null
      ) {
        fetchImage(
          "footerImage",
          hospitalDetails.reportHeaderDto.footerImageUrl,
          APIs.GETFOOTERIMAGE
        );
      }
      if (
        hospitalDetails?.signature2Dto?.signatureImageUrl != "" &&
        hospitalDetails?.signature2Dto?.signatureImageUrl != null
      ) {
        fetchImage(
          "signature2Image",
          hospitalDetails.signature2Dto.signatureImageUrl,
          APIs.GETSIGNATUREIMAGE
        );
      }
      if (
        hospitalDetails?.signature3Dto?.signatureImageUrl != "" &&
        hospitalDetails?.signature3Dto?.signatureImageUrl != null
      ) {
        fetchImage(
          "signature3Image",
          hospitalDetails.signature3Dto.signatureImageUrl,
          APIs.GETSIGNATUREIMAGE
        );
      }
    }
  }, [hospitalDetails]);

  const handleSubmitCustom = () => {
    if (!(roles[0] === USERTYPES.FIRMADMIN && !ownFirm)) {
      if (selectedCountry === "") values.country = "";
      else values.country = selectedCountry.label;
      if (selectedCity === "") values.city = "";
      else values.city = selectedCity.label;
      if (selectedState === "") values.state = "";
      else values.state = selectedState.label;
    }

    if (
      action === ACTIONS.EDIT &&
      roles[0] === USERTYPES.FIRMADMIN &&
      !ownFirm
    ) {
      let validateFlagForFirmAdmin = true;
      if (!validateConfigureSettings(values)) {
        validateFlagForFirmAdmin = false;
      }
      if (!validateOtherSettings(values)) {
        validateFlagForFirmAdmin = false;
      }
      if (
        !validateAutoAssignmentSettings(values, selectedModalityAndSubModality)
      ) {
        validateFlagForFirmAdmin = false;
      }
      if (selectedRadiologistMap.size > 0 || selectedSupervisorMap.size > 0) {
        let allValuesAreNonEmpty = true;
        let noModalityRadiologistName = "";
        let noModalitySupervisorName = "";
        for (let [key, value] of selectedRadiologistMap) {
          if (value.length === 0 || value.some((value) => value === "")) {
            allValuesAreNonEmpty = false;
            noModalityRadiologistName = radiologistList.find(
              (obj) => obj.id == key
            ).username;
            break;
          }
        }

        for (let [key, value] of selectedSupervisorMap) {
          if (value.length === 0 || value.some((value) => value === "")) {
            allValuesAreNonEmpty = false;
            noModalitySupervisorName = supervisorList.find(
              (obj) => obj.id == key
            ).username;
            break;
          }
        }
        if (!allValuesAreNonEmpty) {
          validateFlagForFirmAdmin = false;
          if (noModalityRadiologistName != "") {
            setTabStatusInitialValue(() => {
              const newStatus = { ...tabStatusInitialValue };
              newStatus["tab11Status"] = { value: "Info", color: "red" };
              return newStatus;
            });
            setShowSelectModalityDialog(true);
            setNoSelectionErrorMessage(
              'Select atleast one modality for radiologist " ' +
                noModalityRadiologistName +
                ' "'
            );
          }
          if (noModalitySupervisorName != "") {
            setTabStatusInitialValue(() => {
              const newStatus = { ...tabStatusInitialValue };
              newStatus["tab12Status"] = { value: "Info", color: "red" };
              return newStatus;
            });
            setShowSelectModalityDialog(true);
            setNoSelectionErrorMessage(
              'Select atleast one modality for supervisor " ' +
                noModalitySupervisorName +
                ' "'
            );
          }
          return;
        }
      }

      if (validateFlagForFirmAdmin) {
        setSubmitClick(true);
        handleSubmit();
      }
      return;
    }

    let validateFLag = true;

    if (!validateContact(values)) {
      validateFLag = false;
    }
    if (!validateHospitalDetails(values)) {
      validateFLag = false;
    }
    if (!validateHospitalSettings(values)) {
      validateFLag = false;
    }
    if (
      !validateAutoAssignmentSettings(values, selectedModalityAndSubModality)
    ) {
      validateFLag = false;
    }
    if (!validatePacsNode(pacsNodeList)) {
      validateFLag = false;
    }
    
    if (validateFLag == true) {
      setSubmitClick(true);
      handleSubmit();
    }
  };

  useEffect(() => {
    if (!showSelectModalityDialog) setNoSelectionErrorMessage("");
  }, [showSelectModalityDialog]);

  const handleClearImage = (imageType) => {
    if (imageType === 'header') {
      console.log("In headerImageType");
      setHeaderImageFileName(null);
      setIsHeaderFileDeleted(true);
      setValues({
        ...values,
        reportHeaderDto: {
          ...values.reportHeaderDto,
          isHeaderImageDeleted: 1,
          headerImageUrl: null,
          headerImage: null,
        }
      })
    }
    if (imageType === 'footer') {
      console.log("In footerImageType");
      setFooterImageFileName(null);
      setIsFooterFileDeleted(true);
      setValues({
        ...values,
        reportHeaderDto: {
              ...values.reportHeaderDto,
         footerImageUrl: null,
          footerImage: null,
         isFooterImageDeleted: 1
            }
      })
    }

    if (imageType === 'signature2') {
      console.log("In signatureFile2");
      setIsSignatureFile2Deleted(true);
      setValues({
        ...values,
        signature2Dto: {
              ...values.signature2Dto,
       isSignatureImageDeleted: 1,
        signatureFile2 : null,
        signature2Text: "",
    signatureImageUrl: ""
            }
      })
    }

    if (imageType === 'signature3') {
      console.log("In signatureFile3");
      setIsSignatureFile3Deleted(true);
      setValues({
        ...values,
        signature3Dto: {
          ...values.signature3Dto,
          isSignatureImageDeleted: 1,
        signatureFile3 : null,
        signature2Text: "",
    signatureImageUrl: ""
            }
      })
    }
  }

  const handleCancel = async () => {
    if (action === ACTIONS.ADD) {
      navigate(AuthRoutes.CLIENTLIST);
    } else if (action === ACTIONS.EDIT) {

      setSelectedModalityAndSubModality([]);
      setSelectedRadiologistMap(new Map());
      setSelectedSupervisorMap(new Map());
      setSelectedPacsList([]);
      setCheckAllRadiologist(false);
      setCheckAllSupervisor(false);
      setCheckAllPacs(false);
      setSelectedPediatricModalityId([]);
      setAction(ACTIONS.VIEW);
      setBreadCrumBItems(
        viewBreadCrumbItems(
          state,
          enterprise,
          ownFirm,
          roles[0],
          window.location,
          viewWarningOnly,
          parseInt(searchParams.get("type"))
        )
      );
      // await fetchData();
      navigate(
        AuthRoutes.FIRMDETAILS +
          "?firmId=" +
          parseInt(searchParams.get("firmId")) +
          "&type=" +
          parseInt(searchParams.get("type"))
      );
    }
  };

  const validateTabs = (tabNo) => {
    setSubmitClick(false);
    setSelectedValue(tabNo);
    if (action === ACTIONS.VIEW) return;

    if (
      action === ACTIONS.EDIT &&
      roles[0] === USERTYPES.FIRMADMIN &&
      !ownFirm
    ) {
      tabNo === "3" && validateConfigureSettings(values);
      tabNo === "4" && validateOtherSettings(values);
      tabNo === "7" &&
        validateAutoAssignmentSettings(values, selectedModalityAndSubModality);
      return;
    }
    tabNo === "1" && validateFirstTab();
    tabNo === "2" && validateSecondTab();
    tabNo === "3" && validateThirdTab();
    tabNo === "4" && validateForthTab();
    tabNo === "5" && validateFifthTab();
  };

  const validateFirstTab = () => {
    if (action === ACTIONS.EDIT && roles[0] === USERTYPES.FIRMADMIN) return;
    return validateHospitalDetails(values);
  };

  const validateSecondTab = () => {
    if (action === ACTIONS.EDIT && roles[0] === USERTYPES.FIRMADMIN) return;
    return validateContact(values);
  };

  const validateThirdTab = () => {
    setErrorContactState(() => {
      const newVal = { ...errorContactState };
      newVal.tabStatusInitialValue.tab3Status = {
        value: "Completed",
        color: "green",
      };
      return newVal;
    });
    return true;
  };

  const validateForthTab = () => {
    setErrorContactState(() => {
      const newVal = { ...errorContactState };
      newVal.tabStatusInitialValue.tab4Status = {
        value: "Completed",
        color: "green",
      };
      return newVal;
    });
    return true;
  };

  const validateFifthTab = () => {
    return validateHospitalSettings(values);
  };

  const handleRegion = (varCountry, varState, varCity) => {
    const country =
      varCountry === "Undefined"
        ? undefined
        : Country.getAllCountries().filter(
            (country) => country.name === varCountry
          )[0];

    let state;
    if (country != undefined) {
      state =
        varState === "Undefined"
          ? undefined
          : State.getStatesOfCountry(country.isoCode).filter(
              (state) => state.name === varState
            )[0];
    }
    let city;
    if (state != undefined) {
      city =
        varCity === "Undefined"
          ? undefined
          : City.getCitiesOfState(country.isoCode, state.isoCode).filter(
              (city) => city.name === varCity
            )[0];
    }

    if (country !== undefined) {
      setSelectedCountry({
        value: country.isoCode,
        label: country.name,
      });
    }
    if (state !== undefined) {
      setSelectedState({
        value: state.isoCode,
        label: state.name,
      });
    }
    if (city !== undefined) {
      setSelectedCity({
        value: city.name,
        label: city.name,
      });
    }
  };

  const handleEdit = () => {
    handleRegion(values.country, values.state, values.city);
    if (ownFirm) {
      setAction(ACTIONS.EDIT);
      setBreadCrumBItems(
        editBreadCrumbItems(
          state,
          enterprise,
          ownFirm,
          roles[0],
          parseInt(searchParams.get("type"))
        )
      );
      navigate(AuthRoutes.EDITHOSPITAL, {
        state: {
          firmDto: hospitalDetails,
          action: ACTIONS.EDIT,
          type: firmType,
          id: currFirmId,
        },
      });
    } else {
      setAction(ACTIONS.EDIT);
      setBreadCrumBItems(
        editBreadCrumbItems(
          state,
          enterprise,
          ownFirm,
          roles[0],
          parseInt(searchParams.get("type"))
        )
      );
      navigate(
        AuthRoutes.EDITHOSPITAL +
          "?firmId=" +
          parseInt(searchParams.get("firmId")) +
          "&type=" +
          parseInt(searchParams.get("type")),
        {
          state: {
            firmDto: hospitalDetails,
            action: ACTIONS.EDIT,
            type: firmType,
            id: currFirmId,
          },
        }
      );
      // fetchData()
    }
  };

  const handleEditConfiguration = () => {
    setSelectedValue(6);
    setEditConfigurationSetting(true);
    // state = {action:ACTIONS.EDIT};
    setAction(ACTIONS.EDIT);
  };

const handleSaveConfiguration = async () => {
    let dataMap = {
        clientAccessDto: {
            firmId: firmId,
            clientId: currFirmId,
            radiologistIdList: values.radiologistIdList || [],
            supervisorIdList: values.supervisorIdList || []
        },
        qcSettingDto: {
            firmId: firmId,
            clientId: currFirmId,
            qcEnabled: values.qcEnabled ? 1 : 0,
            twoSignaturesAllowed: values.twoSignaturesAllowed ? 1 : 0,
            modalityIds: values.modalityIds,
        },
        unassignmentServiceDto: {
            firmId: firmId,
            clientId: currFirmId,
            firmEnableUnassignmentService: values.firmEnableUnassignmentService
        },

        historyAvailableDto: {
            firmId: firmId,
            clientId: currFirmId,
            historyAvailable: values.historyAvailable,
            clinicalNoteMandatory: values.clinicalNoteMandatory,
            subModalityMandatory: values.subModalityMandatory
        },
        autoAssignEnableDto: {
            firmId: firmId,
            clientId: currFirmId,
            autoAssignEnabled: values.autoAssignEnable ? 1 : 0,
            modalityIds: values.autoAssignModalityIds,
            modalityWithSubModalityIds: formattedAutoAssignModality(),
            exactMatchEnabled: values.exactMatchEnable,
            pediatricAssignmentEnabled: values.pediatricAssignmentEnabled ? 1 : 0,
            selectedPediatricModalityId: values.selectedPediatricModalityId,
        },
        disclaimerDto: {
            firmId: firmId,
            clientId: currFirmId,
            addPrintDisclaimer: values.addPrintDisclaimer ? 1 : 0,
            printDisclaimerText: values.printDisclaimerText,
            accountWarning: values.accountWarning,
            showPriorsStudies: values.showPriorsStudies
        },
        
        FirmSettingsDto:{
            enableSecondaryCapture: values.enableSecondaryCapture,
            enableGenkiStudyInference: values.enableGenkiStudyInference
}
    };

    let genericdto = { data: dataMap };

    console.log("Payload being sent:", genericdto); // Add logging to debug
    const response = await saveFirmSettingDetails(genericdto);
    if (response.status === 200 && response.data.result === "SUCCESS") {
        action = "VIEW";
        setEditConfigurationSetting(false);
    }
};

  const handleCloseConfiguartion = () => {
    action = "VIEW";
    setEditConfigurationSetting(false);
    handleCancel();
  };

  const getBreadCrumbItems = () => {
    action == "EDIT"
      ? setBreadCrumBItems(
          editBreadCrumbItems(
            state,
            enterprise,
            ownFirm,
            roles[0],
            parseInt(searchParams.get("type"))
          )
        )
      : action == "ADD"
      ? setBreadCrumBItems(
          addbreadCrumbItems(
            state,
            enterprise,
            roles[0],
            parseInt(searchParams.get("type"))
          )
        )
      : setBreadCrumBItems(
          viewBreadCrumbItems(
            state,
            enterprise,
            ownFirm,
            roles[0],
            window.location,
            viewWarningOnly,
            parseInt(searchParams.get("type"))
          )
        );
  };

  let tabDetails = getFirmTabs(
    handleCancel,
    setTotalTabs,
    roles,
    values,
    errorContactState,
    t,
    ownFirm,
    handleChange,
    handleClearImage,
    setIsHeaderFileDeleted,
    isHeaderFileDeleted,
    setIsFooterFileDeleted,
    isFooterFileDeleted,
    setIsSignatureFile2Deleted,
    isSignatureFile2Deleted,
    setIsSignatureFile3Deleted,
    isSignatureFile3Deleted,
    
    handleBlur,
    errors,
    touched,
    state,
    action,
    editConfigurationSetting,
    choiceGroupStyles,
    headerImageValue,
    footerImageValue,
    signature2ImageValue,
    signature3ImageValue,
    modalityList,
    modalityWithSubModalityList,
    selectedCountry,
    setSelectedCountry,
    selectedState,
    setSelectedState,
    selectedCity,
    setSelectedCity,
    historyModalityList,
    firmGlobalErrorState,
    viewWarningOnly,
    isMinimal,
    headerImageFileName,
    setHeaderImageFileName,
    footerImageFileName,
    setFooterImageFileName,
    selectedModalityAndSubModality,
    setSelectedModalityAndSubModality,
    parseInt(searchParams.get("type")),
    selectedRadiologistMap,
    setSelectedRadiologistMap,
    radiologistList,
    setRadiologistList,
    checkAllRadiologist,
    setCheckAllRadiologist,
    selectedSupervisorMap,
    setSelectedSupervisorMap,
    supervisorList,
    setSupervisorList,
    checkAllSupervisor,
    setCheckAllSupervisor,
    tabStatusInitialValue,
    setTabStatusInitialValue,
    firmListForProviders,
    hospitalCheckList,
    setHospitalCheckList,
    pacsNodeList,
    setPacsNodeList,
    availablePacsList, 
    setAvailablePacsList,
    checkAllPacs, 
    setCheckAllPacs,
    selectedPacsList, 
    setSelectedPacsList,
    showPriorsStudiesList, 
    setShowPriorsStudiesList
  );

  useEffect(() => {
    resetValues(action);
  }, [action]);

  const headerTopButtons = [
    {
      key: "1",
      button: (
        <PrimaryButton
          key="1"
          style={{
            marginLeft: "10px",
            display:
              ((roles[0] === USERTYPES.ADMIN ||
                roles[0] === USERTYPES.FIRMTECHNICIAN ||
                roles[0] === USERTYPES.FIRMDOCTOR ||
                (roles[0] === USERTYPES.FIRMADMIN && ownFirm)) &&
              action === ACTIONS.EDIT) || viewWarningOnly
                ? "none"
                : "inline-block",
          }}
          text={t("hospital.edit-header-template")}
          onClick={() => {
            if (
              roles[0] === USERTYPES.ADMIN ||
              roles[0] === USERTYPES.FIRMTECHNICIAN ||
              roles[0] === USERTYPES.FIRMDOCTOR
            ) {
              navigate(AuthRoutes.EDITHEADERTEMPLATE + "?firmId=" + values.id);
            } else if (roles[0] === USERTYPES.FIRMADMIN) {
              navigate(AuthRoutes.EDITHEADERTEMPLATE);
            }
          }}
        />
      ),
    },
  ];

  const topButtons = [
    !values?.isClientWarning && {
      key: "1",
      button: (
        <PrimaryButton
          key="1"
          style={{
            marginLeft: "10px",
            display:
              action === ACTIONS.EDIT ||
              roles[0] === USERTYPES.FIRMDOCTOR ||
              (roles[0] === USERTYPES.FIRMTECHNICIAN && !isMinimal)
                ? "none"
                : "inline-block",
          }}
          text={t("button.edit")}
          onClick={handleEdit}
        />
      ),
    },
    // roles[0] === USERTYPES.ADMIN && {
    //   key: "2",
    //   button: (
    //     <PrimaryButton
    //       key="1"
    //       style={{
    //         marginLeft: "10px",
    //         display:
    //           roles[0] === USERTYPES.ADMIN &&
    //           (action === ACTIONS.EDIT || isMinimal)
    //             ? "none"
    //             : "inline-block",
    //       }}
    //       text={t("hospital.firm-admin")}
    //       onClick={() =>
    //         navigate(AuthRoutes.FIRMADMINUSERLIST + "?firmId=" + values.id)
    //       }
    //     />
    //   ),
    // },
    // roles[0] === USERTYPES.ADMIN && {
    //   key: "3",
    //   button: (
    //     <PrimaryButton
    //       key="1"
    //       style={{
    //         marginLeft: "10px",
    //         display:
    //           roles[0] === USERTYPES.ADMIN &&
    //           (action === ACTIONS.EDIT || isMinimal)
    //             ? "none"
    //             : "inline-block",
    //       }}
    //       text={t("hospital.supervisor")}
    //       onClick={() =>
    //         navigate(AuthRoutes.SUPERVISORLIST + "?firmId=" + values.id)
    //       }
    //     />
    //   ),
    // },
  ];

  const ClientTopButtons = [
    !values?.isClientWarning && {
      key: "1",
      button: (
        <PrimaryButton
          key="1"
          style={{
            marginLeft: "10px",
            display:
              action === ACTIONS.EDIT || viewWarningOnly
                ? "none"
                : "inline-block",
          }}
          text={t("hospital.edit")}
          onClick={handleEdit}
        />
      ),
    },
    editConfigurationSetting && {
      key: "2",
      button: (
        <DefaultButton
          key="2"
          style={{ marginLeft: "10px" }}
          text={t("button.cancel")}
          onClick={handleCloseConfiguartion}
        />
      ),
    },
    editConfigurationSetting && {
      key: "3",
      button: (
        <PrimaryButton
          key="3"
          style={{ marginLeft: "10px" }}
          text={t("button.save")}
          onClick={handleSaveConfiguration}
        />
      ),
    },
  ];

  const saasTopButtons = () => {
    // roles[0] != USERTYPES.FIRMADMIN ? action == ACTIONS.VIEW ? topButtons : [] : action == ACTIONS.VIEW ? ClientTopButtons : []

    if (parseInt(searchParams.get("type")) === 1)
      return [
        {
          key: "1",
          button: (
            <PrimaryButton
              key="1"
              style={{
                marginLeft: "10px",
                display: action === ACTIONS.EDIT || viewWarningOnly ? "none" : "inline-block",
              }}
              text={t("hospital.edit")}
              onClick={handleEdit}
            />
          ),
        },
      ];

    if (roles[0] === USERTYPES.FIRMADMIN && action !== ACTIONS.ADD) {
      return ownFirm ? topButtons : ClientTopButtons;
    }
    if (
      (roles[0] === USERTYPES.ADMIN ||
        roles[0] === USERTYPES.FIRMTECHNICIAN ||
        roles[0] === USERTYPES.FIRMDOCTOR) &&
      action !== ACTIONS.ADD
    ) {
      return topButtons;
    }
    if (
      roles[0] === USERTYPES.RADIOLOGIST ||
      (roles[0] === USERTYPES.SUPERVISOR && action !== ACTIONS.ADD)
    ) {
      return [];
    }
    return [];
  };

  const tabValidation = (latestVal, previousVal) => {
    validateTabs(previousVal.charAt(previousVal.length - 1));
  };

  return (
    <>
      {" "}
      {authenticated && (
        <>
          {!show ? (
            <NotAllowed msg={t("string-literals.error-msg")} />
          ) : (
            <>
              {(action === ACTIONS.ADD || action === ACTIONS.EDIT) && (
                <>
                  <TabContainer
                    uniqueKey={"firm_"}
                    tabDetails={tabDetails}
                    NoOfTabs={tabDetails.length}
                    onCancelClick={handleCancel}
                    onSubmitClick={handleSubmitCustom}
                    onNextClick={validateTabs}
                    onEditClick={handleEdit}
                    previousNextButton={true}
                    state={state}
                    action={action}
                    breadCrumbItems={breadCrumbItems}
                    topButtons={
                      enterprise
                        ? action == ACTIONS.VIEW
                          ? topButtons
                          : []
                        : saasTopButtons()
                    }
                    tabValidation={tabValidation}
                    defaultSelectedValue={
                      viewWarningOnly ? tabDetails.length : 1
                    }
                  />
                  <DialogBox
                    setShowDialogBox={setShowSelectModalityDialog}
                    showDialogBox={showSelectModalityDialog}
                    title={t("user.alert")}
                    message={noSelectionErrorMessage}
                    confirmButtonText={t("user.ok")}
                  />
                </>
              )}
              {action === ACTIONS.VIEW && (
                <TabContainer
                  uniqueKey={"firm_"}
                  tabDetails={tabDetails}
                  NoOfTabs={tabDetails.length}
                  onCancelClick={handleCancel}
                  onSubmitClick={handleSubmitCustom}
                  onNextClick={validateTabs}
                  onEditClick={handleEdit}
                  previousNextButton={true}
                  state={state}
                  action={action}
                  breadCrumbItems={breadCrumbItems}
                  headerTopButtons={headerTopButtons}
                  topButtons={
                    enterprise
                      ? action == ACTIONS.VIEW
                        ? topButtons
                        : []
                      : saasTopButtons()
                  }
                  tabValidation={tabValidation}
                  defaultSelectedValue={viewWarningOnly ? tabDetails.length : 1}
                />
              )}
            </>
          )}
        </>
      )}
    </>
  );
};

export default Firm;
